// 3rd party
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Rx';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';

// components
import { AppComponent } from './../../app.component';
import { StandardCalibrationListComponent } from 'app/standards/standard-calibration-list/standard-calibration-list.component';
import { LayoutMainComponent } from 'app/shared/layout/layout-main/layout-main.component';

// helpers
import { Helper } from 'app/shared/helpers/helper';

// models
import { ContactCustomer, ERoleActionWebview } from 'app/shared/models/contact-customer.model';
import { StandardCalibration } from 'app/standards/shared/standard-calibration.model';
import { StoredFile } from 'app/shared/models/stored-file.model';

// services
import { DialogsService } from './../../shared/services/dialog/dialog.service';
import { StandardService } from './../shared/standard.service';
import { StoredFileService } from 'app/shared/services/stored-file.service';

@Component({
  selector: 'app-standard-calibration',
  templateUrl: './standard-calibration.component.html',
  styleUrls: ['./standard-calibration.component.css']
})
export class StandardCalibrationComponent implements OnInit, OnDestroy {

  @ViewChild('standardCalibrationPanel') standardCalibrationPanel: MatExpansionPanel;
  @ViewChild('pdfViewer') pdfViewer: PdfJsViewerComponent;

  hasViewCertificatePermission: boolean = false;
  isLoading: boolean = false;
  standardCalibration: StandardCalibration = new StandardCalibration();
  subscribe1: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private app: AppComponent,
    public dialog: DialogsService,
    public mainLayout: LayoutMainComponent,
    public Router: Router,
    public standardCalibrationList: StandardCalibrationListComponent,
    private standardService: StandardService,
    public storedFileService: StoredFileService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.standardCalibrationPanel.expanded = true;

    this.subscribe1 = this.activatedRoute.params.subscribe(params => {
      let id = params['identifier'];
      if (!id) {
        return;
      }

      this.standardCalibrationList.sidenavRight.open();
      this.standardService.getStandardCalibrations(id).subscribe(res => {
        this.standardCalibration = Helper.deserialize(res.text())[0];
      });
    });

    this.checkPermissions();
  }

  ngOnDestroy() {
    if (this.subscribe1) {
      this.subscribe1.unsubscribe();
    }
    this.standardCalibrationList.sidenavRight.close();
  }

  checkPermissions() {
    const contact = JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer;
    this.hasViewCertificatePermission = ContactCustomer.hasPermission(ERoleActionWebview.StandardsView, contact.RoleWebView.ActionsPermissions);
  }

  close() {
    this.standardCalibrationList.sidenavRight.close();
    this.Router.navigate([`/${this.app.currentContact.Domain}/standards`]);
  }

  view() {
    this.isLoading = true;
    let lstFilters = '"StandardCalibration.Identifier_in(\'' + this.standardCalibration.Identifier + '\')"';
    let lstFields = '"SystemFileName","UserFileName","StandardCalibration.CertificateCode"';
    let storedFiles: any[] = [];

    this.storedFileService.get(null, null, null, null, null, null, lstFilters, lstFields)
      .subscribe(value => {
        storedFiles = value.json() as StoredFile[];
        if (!storedFiles || storedFiles.length === 0) {
          this.dialog.error('Message.ErrorAlert', 'Message.ViewCertificateError');
          this.isLoading = false;
        }
        this.storedFileService.download(storedFiles as StoredFile[])
          .subscribe(data => {
            this.isLoading = false;
            if (data) {
              const file = new Blob([data], { type: data.type });

              this.storedFileService.view(file, false, this.pdfViewer, `Certificado ${this.standardCalibration.CertificateCode}`);

            } else {
              this.dialog.error('Message.ErrorAlert', 'Message.ViewCertificateError');
            }
          }, () => {
            this.dialog.error('Message.ErrorAlert', 'Message.OpenStandardCertificateError');
            this.isLoading = false;
          });
      }, () => { this.dialog.error('Message.ErrorAlert', 'Message.OpenStandardCertificateError'); this.isLoading = false; });
  }
}



// WEBPACK FOOTER //
// ./src/app/standards/standard-calibration/standard-calibration.component.ts